import { Form, Select, Button, DatePicker, Row, Col } from "antd";
import find from "lodash/find";
import map from "lodash/map";
import get from "lodash/get";
import dayjs from "dayjs";
import { getButtonDisabled } from "../../../utilities/helpers";
import { PNL_PERMISSION } from "../../../constants";

const HeaderSelector = ({
  filter,
  config,
  form,
  setFilters,
  setConfig,
  getSummary,
  setManagerSummary
}) => {
  const disabledDate = (current) => {
    return current > dayjs().endOf("day");
  };

const companies = get(config, "companies", [])
  .filter(company =>
    find(get(company, "feature_permissions", []), ['key', PNL_PERMISSION])
  )
  .map(company => ({
    label: get(company, "name"),
    value: get(company, "id"),
  }));
  
  return (
    <Row className="" gutter={18}>
      <Col xs={24} md={6}>
        <Form.Item
          name="Company"
          label="Company"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            value={get(filter, "company")}
            optionFilterProp="label"
            showSearch
            placeholder="Select Company"
            options={companies}
            onChange={(val) => {
              const company = find(get(config, "companies"), ["id", val]);
              setFilters({
                ...filter,
                templateType: undefined,
                company,
              });

              setConfig({
                ...config,
                templates: get(company, "template_access_list"),
              });
              form.setFieldsValue({
                template: undefined,
              });
              setManagerSummary([])
            }}
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={6}>
        <Form.Item
          name="template"
          label="Template"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            placeholder="Select Template"
            options={map(get(config, "templates"), (template) => ({
              label: get(template, "name"),
              value: get(template, "value"),
            }))}
            value={get(filter, "templateType")}
            onChange={(value) => {
              setFilters({
                ...filter,
                templateType: value,
              });
              setManagerSummary([])
            }}
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={6}>
        <Form.Item name="Date" label="Date" colon={false} layout="vertical">
          <DatePicker
            format={"DD/MM/YYYY"}
            disabledDate={disabledDate}
            style={{ minWidth: 250 }}
            onChange={(val) => {
              setFilters({
                ...filter,
                date: val,
              });
            }}
            defaultValue={get(filter, "date")}
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={6}>
        <Form.Item name="submit" label=" " colon={false} layout="vertical">
          <Button
            type="primary"
            className="w-60"
            onClick={getSummary}
            disabled={getButtonDisabled(filter, [
              "templateType",
              "company",
              "date",
            ])}
          >
            Submit
          </Button>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default HeaderSelector;
